import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const QrCodeIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 23 22">
    <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="10.2778"
        y="19.5555"
        width="2.44444"
        height="2.44444"
        fill="currentColor"
      />
      <rect
        x="2.94446"
        y="9.77777"
        width="2.44444"
        height="2.44444"
        transform="rotate(90 2.94446 9.77777)"
        fill="currentColor"
      />
      <rect
        x="10.2778"
        y="14.6667"
        width="2.44444"
        height="2.44444"
        fill="currentColor"
      />
      <rect
        x="7.83337"
        y="9.77777"
        width="2.44444"
        height="2.44444"
        transform="rotate(90 7.83337 9.77777)"
        fill="currentColor"
      />
      <rect
        x="10.2778"
        y="9.77777"
        width="2.44444"
        height="2.44444"
        fill="currentColor"
      />
      <rect
        x="12.7222"
        y="9.77777"
        width="2.44444"
        height="2.44444"
        transform="rotate(90 12.7222 9.77777)"
        fill="currentColor"
      />
      <rect
        x="10.2778"
        y="4.88889"
        width="2.44444"
        height="2.44444"
        fill="currentColor"
      />
      <rect
        x="17.6111"
        y="9.77777"
        width="2.44444"
        height="2.44444"
        transform="rotate(90 17.6111 9.77777)"
        fill="currentColor"
      />
      <rect
        x="17.6111"
        y="14.6667"
        width="2.44444"
        height="2.44444"
        transform="rotate(90 17.6111 14.6667)"
        fill="currentColor"
      />
      <rect
        x="17.6111"
        y="19.5555"
        width="2.44444"
        height="2.44444"
        transform="rotate(90 17.6111 19.5555)"
        fill="currentColor"
      />
      <rect
        x="10.2778"
        width="2.44444"
        height="2.44444"
        fill="currentColor"
      />
      <rect
        x="22.5"
        y="9.77777"
        width="2.44444"
        height="2.44444"
        transform="rotate(90 22.5 9.77777)"
        fill="currentColor"
      />
      <rect
        x="22.5"
        y="14.6667"
        width="2.44444"
        height="2.44444"
        transform="rotate(90 22.5 14.6667)"
        fill="currentColor"
      />
      <rect
        x="22.5"
        y="19.5555"
        width="2.44444"
        height="2.44444"
        transform="rotate(90 22.5 19.5555)"
        fill="currentColor"
      />
      <rect
        x="16.1666"
        y="1"
        width="5.33333"
        height="5.33333"
        stroke="currentColor"
        strokeWidth="2"
      />
      <rect
        x="1.5"
        y="1"
        width="5.33333"
        height="5.33333"
        stroke="currentColor"
        strokeWidth="2"
      />
      <rect
        x="1.5"
        y="15.6667"
        width="5.33333"
        height="5.33333"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  </SvgIcon>
);

export default QrCodeIcon;
